<template>
  <div
    @mouseover="resolveHover(true)"
    @mouseleave="resolveHover(false)">
    <form v-on:submit.prevent="submitSearch" novalidate class="uk-search uk-width-1-1"
          :class="{'search-form-default': !inputActive, 'search-form-white': inputActive}">
      <span v-if="searchPage && isMobileWidth" @click="toggleFilters" class="add-pointer">
      <img v-if="!inputActive" :src="whiteMobileMenuIcon">
        <img v-else :src="slateMobileMenuIcon">
      </span>
      <span class="clear-search-icon add-pointer">
        <img v-if="searchTerm" :src="clearTextIcon" @click="removeSearchText">
      </span>
      <input autocomplete="off" required id="Search" class="uk-search-input" type="search"
             :placeholder="$t('general.searchForResources')"
             :class="{'search-input-default': !inputActive, 'search-input-white': inputActive}"
             v-model="searchText"
             @focus="resolveFocus(true)"
             @blur="resolveFocus(false)">
      <img v-if="!inputActive" class="uk-position-right perform-search-icon add-pointer" :src="whiteSearchIcon">
      <img v-else-if="inputActive & moderateResources" class="uk-position-right perform-search-icon add-pointer" :src="slateSearchIcon">
      <router-link v-else :to="{name: 'Search', query:{searchText:dirtyText, key: new Date().getTime()}}">
        <img class="uk-position-right perform-search-icon
      add-pointer" :src="slateSearchIcon">
      </router-link>
    </form>
    <leave-page-modal
      :id="leaveSearchBar"
      @leave-page="leavePage">
    </leave-page-modal>
  </div>
</template>
<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import screen from '../../utils/screen-util'
  import selectedFilters from '../../utils/selected-filters-util'
  import * as grades from '../../enums/grades'
  import * as subjects from '../../enums/subjects'
  import * as contentType from '../../enums/content-type'
  import gradeUtil from '../../utils/grade-util'
  import * as event from '../../enums/mixpanel-event'
  import * as misc from '../../enums/misc'
  import iconUtil from '../../utils/icon-util'
  import leavePageModal from '../ui-components/modals/leave-page'
  import UIkit from 'uikit'
  import * as routes from '../../enums/routes'
  import mixpanel from '../../services/mixpanel'

  export default {
    name: 'SearchBar',
    components: {
      leavePageModal
    },
    data() {
      return {
        dirtyText: null,
        searchPage: window.location.pathname === '/search',
        screenWidth: 0,
        clearTextIcon: iconUtil.resolve(misc.CLOSE_SLATE_14PX),
        whiteSearchIcon: iconUtil.resolve(misc.SEARCH_ICON_WHITE),
        slateSearchIcon: iconUtil.resolve(misc.SEARCH_ICON),
        whiteMobileMenuIcon: iconUtil.resolve(misc.FILTER_WHITE),
        slateMobileMenuIcon: iconUtil.resolve(misc.FILTER_SLATE),
        hover: false,
        focus: false,
        leaveSearchBar: 'leave-search-bar',
        isMobileWidth: false
      }
    },
    computed: {
      ...mapGetters(['searchTerm', 'filters', 'getResourceDataAdded']),
      searchText: {
        get: function () {
          return this.searchTerm
        },
        set: function (newVal) {
          this.setSearchCriteria({searchText: newVal})
          this.dirtyText = newVal
        }
      },
      inputActive: {
        get: function () {
          return this.hover || this.searchTerm || this.focus
        }
      },
      moderateResources() {
        return this.$route.name === routes.ROUTE_NAME_MODERATE_RESOURCE || this.$route.name === routes.ROUTE_NAME_MODERATE_RESOURCES
      },
      shareResources() {
        return this.$route.name === routes.SHARE_RESOURCE
      }
    },
    methods: {
      ...mapActions(['performSearch', 'setSearchCriteria', 'setMobileFiltersVisibility', 'cleanSetSearchCriteria']),
      ...mapMutations(['setResourceDataAdded', 'moderatorSearchTerm']),
      resolveHover(hover) {
        this.hover = hover
      },
      resolveFocus(focus) {
        this.focus = focus
      },
      resolveIcon(icon) {
        return iconUtil.resolve(icon)
      },
      removeSearchText() {
        this.searchText = null
      },
      submitSearch() {
        if (this.shareResources) {
          if (this.getResourceDataAdded) {
            UIkit.modal('#leave-search-bar').show()
          } else {
            this.search()
          }
        } else if (!this.shareResources && !this.moderateResources) {
          this.search()
        }
      },
      search() {
        this.cleanSetSearchCriteria(this.dirtyText)
        var key = new Date().getTime()
        this.performSearch({searchText: this.dirtyText, key: key})
        mixpanel.track(event.SEARCH_RESOURCES, {
          searchTerm: this.searchTerm,
          grades: this.resolveGrades(),
          subjects: this.resolveSubjects(),
          contentType: this.resolveContentType()
        })
      },
      leavePage() {
        this.setResourceDataAdded(false)
        setTimeout(() => {
          this.search()
        }, 500)
      },
      toggleFilters() {
        this.setMobileFiltersVisibility()
      },
      resolveWindowWidth() {
        this.screenWidth = screen.resolveWidth()
        this.isMobileWidth = this.screenWidth < 1024
      },
      resolveGrades() {
        let selectedGrades = ''
        try {
          let gradeFilters = this.resolveFilter(grades.GRADES_TITLE)
          for (let grade of gradeFilters) {
            selectedGrades = selectedGrades + ' ' + gradeUtil.resolve(grade)
          }
          return selectedGrades
        } catch (err) {
          return null
        }
      },
      resolveSubjects() {
        let selectedSubjects = ''
        try {
          let subjectFilters = this.resolveFilter(subjects.SUBJECTS_TITLE)
          for (let subject of subjectFilters) {
            selectedSubjects = selectedSubjects + ' ' + subject
          }
          return selectedSubjects
        } catch (err) {
          return null
        }
      },
      resolveFilter(filterGroup) {
        let filters = selectedFilters.resolve(this.filters)
        if (filters.find(o => o.filterGroup === filterGroup).selectedFilters.length) {
          return filters.find(o => o.filterGroup === filterGroup).selectedFilters
        } else {
          return null
        }
      },
      resolveContentType() {
        let selectedContentType = ''
        try {
          let contentTypeFilters = this.resolveFilter(contentType.CONTENT_TYPE_TITLE)
          for (let type of contentTypeFilters) {
            selectedContentType = selectedContentType + ' ' + type
          }
          return selectedContentType
        } catch (err) {
          return null
        }
      }
    },
    watch: {
      searchTerm(value, newValue) {
        this.searchText = value
      },
      $route: function () {
        this.searchPage = window.location.pathname === '/search'
      }
    },
    mounted() {
      this.searchText = this.searchTerm
      this.resolveWindowWidth()
      window.addEventListener('resize', this.resolveWindowWidth)
    },
    destroyed() {
      window.removeEventListener('resize', this.resolveWindowWidth)
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../styles/breakpoints.scss';
  @import '../../styles/colours.scss';

  .search-form-default {
    background-color: $searchBar-blue;
    height: 56px;
  }

  .search-form-white {
    background-color: white;
    height: 56px;
  }

  .search-input-default {
    width: 80%;
    font-size: 18px;
    border: 0px none;
    background-color: $searchBar-blue;
    height: 56px;
    color: white;

    &::placeholder {
      color: white !important;
      opacity: 1;
    }
  }

  /* required for IE*/
  .search-input-default::-ms-clear {
    display: none;
  }

  /* required for IE*/
  .search-input-default:-ms-input-placeholder {
    color: white !important;
    opacity: 1;
  }

  .search-input-white {
    width: 80%;
    font-size: 18px;
    border: 0px none;
    background-color: white;
    height: 56px;

    &::placeholder {
      caret-color: $searchBar-caret-blue;
      color: #000102 !important;
      fill: #000102 !important;
      opacity: 0.7;
    }
  }

  /* required for IE*/
  .search-input-white::-ms-clear {
    display: none;
  }

  /* required for IE*/
  .search-input-white:-ms-input-placeholder {
    caret-color: $searchBar-caret-blue;
    color: #000102 !important;
    fill: #000102 !important;
    opacity: 0.7;
  }

  .perform-search-icon {
    margin-right: 9px;
    margin-top: 6px;
  }

  .clear-search-icon {
    margin-left: 25px;
    opacity: 0.7;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .search-form-default {
      height: 48px;
    }

    .search-form-white {
      height: 48px;
    }

    .search-input-default {
      height: 48px;
    }
    .search-input-white {
      height: 48px;
    }
  }

  @media screen and (max-width: $breakpoint-medium - 1) {
    form {
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .search-input-white {
      width: 60%;
      font-size: 14px;
    }

    .search-input-default {
      width: 60%;
      font-size: 14px;
    }
  }


</style>
